function animateCounter(element, startValue, endValue, duration) {
        $({ value: startValue }).animate({ value: endValue }, {
            duration: duration,
            step: function (now) {
                element.text(Math.floor(now).toLocaleString());
            }
        });
    }

    function fetchDataAndUpdateStats() {
        $.ajax({
            url: 'https://apps.koihappiness.com/planetkoi/', 
            type: 'GET',
            dataType: 'json',
            success: function (data) {
                animateCounter($('#tree_stat'), 0, parseFloat(data.trees.replace(/,/g, '')), 1000);
                animateCounter($('#bottle_stat'), 0, parseFloat(data.bottles.replace(/,/g, '')), 1000);
            },
            error: function (error) {
                console.log('Error fetching data from API:', error);
            }
        });
    }

$(document).ready(function () {
    if ($('#tree_stat').length > 0) {
        fetchDataAndUpdateStats();    
    }
});